module.exports = __webpack_public_path__ + "static/media/997078.dbd9474c.png";